


<footer *ngIf="currentRoute!='/cart/account' && currentRoute!='/cart/checkout' && currentRoute!='/cart/payment' && currentRoute!='/login' && currentRoute!='/vendor-login' && currentRoute!='/reset-password' && currentRoute!='/reset-password'">
  <div class="container">
    <div class="row">
      <div class="col-md-5">
        <!-- <img [src]="logoPath" class="img-fluid footer-logo" alt="img" /> -->
        <img src="/assets/img/white-new-logo.png" class="img-fluid footer-logo" alt="img" />

        <div class="footer-left-social">
          <a href="">
            <!-- <img src="/assets/img/fb-icon.png" class="img-fluid blk" alt="img" /> -->
            <img src="/assets/img/fb-icon-w.svg" class="img-fluid" alt="img" />
          </a>
          <a href="">
            <!-- <img src="/assets/img/insta-icon.png" class="img-fluid blk" alt="img" /> -->
            <img src="/assets/img/insta-icon-w.svg" class="img-fluid" alt="img" />
          </a>
          <a href="">
            <!-- <img src="/assets/img/link-icon.png" class="img-fluid blk" alt="img" /> -->
            <img src="/assets/img/link-icon-w.svg" class="img-fluid" alt="img" />
          </a>
          

        </div>

      </div>
      <div class="col-md-7 d-flex footer-right-text">
        <div class="w-50">
            <h4 class="mb-4">Company</h4>
            <ul class="footer-list">
              <li>
                <a routerLink="/">
                  Suppliers
                </a>
              </li>
              <li>
                <a routerLink="/terms-conditions">
                  Terms & Conditions
                </a>
              </li>
              <li>
                <a routerLink="/privacy-policy">
                  Privacy Policy
                </a>
              </li>

            </ul>
        </div>

        <div class="w-50">
          <h4 class="mb-4">Support</h4>
          <ul class="footer-list">
            <li>
              <a routerLink="/contact-us">
                Contact Us
              </a>
            </li>
            <li>
              <a routerLink="/tutorials">
                Tutorials
              </a>
            </li>

          </ul>
        </div>

      </div>
    </div>
  </div>
</footer>


<div class="copyrights">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <p>
          &copy; {{ currentYear }} Clockwork | All Rights Reserved.
        </p>
      </div>
    </div>
  </div>
</div>
